import { Alert, Box, Stack, Tab, Tabs } from "@mui/material";
import { LoadingScreen } from "components/LoadingScreen";
import { DeleteModal, Notification } from "components/UI";
import i18next from "i18next";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useCentralStore } from "stores";
import { useChurch, useDeleteChurch } from "../api";
import { Assets } from "../components/Assets";
import { BasicInformation } from "../components/BasicInformation";
import { Leadership } from "../components/Leadership";
import { Notes } from "../components/Notes";
import { ProfileHeader } from "../components/ProfileHeader";

export function ChurchProfile() {
  const [tabValue, setTabValue] = useState(0);

  const { id: churchId } = useParams();
  const setHeaderTitle = useCentralStore(state => state.setHeaderTitle);
  const closeDeleteModal = useCentralStore(state => state.closeDeleteModal);
  const setHeaderBackground = useCentralStore(
    state => state.setHeaderBackground
  );
  const churchQuery = useChurch({ churchId });
  const churchDeleteMutation = useDeleteChurch();
  const { t } = useTranslation();

  useEffect(() => {
    setHeaderTitle(t("churches.createChurch.churchProfile"));

    return () => setHeaderTitle("");
  }, [i18next.language]);

  useEffect(() => {
    setHeaderBackground(false);

    return () => setHeaderBackground(true);
  }, []);

  if (churchQuery.isLoading) {
    return <LoadingScreen />;
  }

  if (churchQuery.isError) {
    return (
      <Alert severity="error">
        {t("churches.profile.errorLoadingChurchData")}
      </Alert>
    );
  }

  const church = churchQuery.data?.result;

  const tabContent = {
    0: <BasicInformation church={church} />,
    1: <Leadership church={church} />,
    2: <Assets church={church} />,
    3: <Notes church={church} />
  };

  return (
    <Stack sx={{ gap: "56px" }}>
      <Notification />
      <DeleteModal
        title={t("form.common.delete")}
        onDelete={() => {
          churchDeleteMutation.mutate({
            churchId
          });
          closeDeleteModal();
        }}
        name={church?.name}
      />

      {/* Header */}
      <ProfileHeader church={church} />

      {/* Tabs */}
      <Box
        sx={{ backgroundColor: "neutral.main", borderRadius: "8px", p: "4px" }}
      >
        <Tabs
          value={tabValue}
          onChange={(event, value) => setTabValue(value)}
          indicatorColor=""
          variant="scrollable"
          scrollButtons="auto"
        >
          {[
            { label: t("churches.profile.basicInfo"), value: 0 },
            { label: t("churches.profile.leadership"), value: 1 },
            { label: t("churches.profile.assets"), value: 2 },
            { label: t("churches.profile.notes"), value: 3 }
          ].map(tab => (
            <Tab
              key={tab.value}
              label={tab.label}
              sx={{
                flex: 1,
                color: "text.primary",
                "&.Mui-selected": {
                  borderRadius: "8px",
                  background: "white",
                  color: "primary.main",
                  boxShadow: "0px 2px 8px 0px rgba(0,0,0,0.08)"
                }
              }}
            />
          ))}
        </Tabs>
      </Box>

      {tabContent[tabValue]}
    </Stack>
  );
}
